// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fddfee02","337":"fc8b394f","732":"5b7cd6b3"}[chunkId] + ".chunk.js";
};